export { getProgramsData } from './getProgramsData'
export { getBannerData } from './getBannerData'
export { getProgramsQuestions } from './getProgramsQuestions'
export { getProgramsVideo } from './getProgramsVideo'
export { getFacultiesData as getProgramsDataFaculties } from './getFacultiesData'
